import script from "./UiAccordion.vue?vue&type=script&lang=js"
export * from "./UiAccordion.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__